import { useState } from 'react';

export const ArduPilot = Symbol();
export const PX4 = Symbol();

const FORM_TYPE = {
  UNDEFINED: 0,
  READ_ONLY: 1,
  FIELD: 2,
  SELECT: 3,
  CHECKBOX: 4,
};

const useParamDocsGenerator = (firmware) => {
  const [paramDocs, setParamDocs] = useState();

  const determineFormType = (param) => {
    if (param.readOnly) return FORM_TYPE.READ_ONLY;
    if (param.bitmask) return FORM_TYPE.CHECKBOX;
    if (param.values) return FORM_TYPE.SELECT;
    if (param.range || param.min || param.max) return FORM_TYPE.FIELD;
    return FORM_TYPE.UNDEFINED;
  };

  const normalizeParamsForArduPilot = (param) => {
    Object.entries(param).forEach(([key, value]) => {
      // 파라미터 키 시작 문자 소문자인 경우 처리 필요 없음
      if (key[0] === key[0].toLowerCase()) return;

      // 파라미터 키 시작 문자 소문자 치환
      const newKey = key[0].toLowerCase() + key.slice(1);
      param[newKey] = value;
      delete param[key];
    });

    return {
      id: param.id,
      name: param.displayName,
      description: param.description,
      units: param.units ?? null,
      formType: determineFormType(param),
      min: param.range?.low ?? null,
      max: param.range?.high ?? null,
      increment: param.increment ?? null,
      values: param.values && Object.entries(param.values).map(([value, description]) => ({ value, description })),
      bitmask: param.bitmask && Object.entries(param.bitmask).map(([index, description]) => ({ index, description })),
    };
  };

  const normalizeParamsForPX4 = (param) => ({
    id: param.name,
    name: param.shortDesc,
    description: param.longDesc,
    units: param.units ?? null,
    formType: determineFormType(param),
    min: param.min ?? null,
    max: param.max ?? null,
    increment: param.increment ?? null,
    values: param.values,
    bitmask: param.bitmask,
  });

  const generateParamDocs = (data) => {
    let convertedParamDocs = {};

    if (firmware === ArduPilot) {
      convertedParamDocs = Object.values(data).reduce((acc, params) => {
        Object.entries(params).forEach(([id, param]) => {
          acc[id] = normalizeParamsForArduPilot({ id, ...param });
        });
        return acc;
      }, {});
    } else if (firmware === PX4) {
      convertedParamDocs = data.parameters.reduce((acc, param) => {
        acc[param.name] = normalizeParamsForPX4(param);
        return acc;
      }, {});
    }

    setParamDocs(convertedParamDocs);
  };

  return {
    paramDocs,
    generateParamDocs,
  };
};

export default useParamDocsGenerator;
